// import React from 'react';
import Loader from 'react-loadable';
import CircularProgress from 'material-ui/CircularProgress';

// const dummy = <div />;
// const loading = Loader({
//   loader: () => import('material-ui/CircularProgress'),
//   loading: dummy,
// });

export const preloader = (loader) => Loader({
  loader,
  loading: CircularProgress,
});

export default preloader;
